import { cn } from "@/components/podkit/lib/cn";
import type { FC, HTMLAttributes, ReactNode } from "react";

export const specModeBorderClass =
    "border border-dashed border-content-brand-accent-01/50 transition-colors focus-within:border-content-brand-accent-01";

type ChatInputShellProps = {
    isDragging: boolean;
    dragHandlers: HTMLAttributes<HTMLDivElement>;
    isSpecMode?: boolean;
    className?: string;
    children: ReactNode;
};

export const ChatInputShell: FC<ChatInputShellProps> = ({
    isDragging,
    dragHandlers,
    isSpecMode,
    className,
    children,
}) => {
    return (
        <div
            className={cn(
                "relative w-full min-w-0 rounded-lg bg-surface-pure shadow-sm",
                isSpecMode ? specModeBorderClass : "border border-border-base",
                isDragging && "ring-2 ring-content-accent ring-offset-2",
            )}
            {...dragHandlers}
        >
            <div className={cn("flex flex-col gap-1 overflow-hidden pb-2 pl-4 pt-4", className)}>{children}</div>
        </div>
    );
};
